module.exports = __webpack_public_path__ + "assets/img/wine-red.abef8520.svg";